import { IOperationConfig } from '../../../ui/OperationsMapper/types'

export const historyConfig: IOperationConfig[] = [
    {
        date: 'Сегодня, 17 июня, пятница',
        operations: [
            { type: 'repayment', time: '12:24', value: '- 2 450 ₽' },
            { type: 'repayment', time: '12:00', value: '- 2 450 ₽' },
            { type: 'refill', time: '9:40', value: '+ 3 800 000 ₽' },
        ],
        flexStart: true,
    },
    {
        date: 'Вчера, 16 июня, четверг',
        operations: [
            { type: 'repayment', time: '12:00', value: '- 225 000 ₽' },
            { type: 'repayment', time: '12:00', value: '- 60 000 ₽' },
        ],
        flexStart: true,
    },
    {
        date: '14 июня, вторник',
        operations: [
            { type: 'repayment', time: '12:00', value: '- 60 000 ₽' },
            { type: 'repayment', time: '12:00', value: '- 2 450 ₽' },
            { type: 'refill', time: '15:59', value: '+ 3 800 000 ₽' },
            { type: 'repayment', time: '12:00', value: '- 2 450 ₽' },
            { type: 'repayment', time: '12:00', value: '- 2 450 ₽' },
            { type: 'repayment', time: '12:00', value: '- 2 450 ₽' },
        ],
        flexStart: true,
    },
]
